<template>
  <div class="regenere-result-page flex flex-col items-center">
    <svg
      class="regenere-warning"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 96 96"
      fill="none"
    >
      <path
        d="M48 10 L90 82 H6 Z"
        stroke="#F2413D"
        stroke-width="4"
        stroke-linejoin="round"
        fill="none"
      />
      <rect
        x="45.5"
        y="36"
        width="5"
        height="26"
        rx="2"
        fill="#F2413D"
      />
      <circle
        cx="48"
        cy="71"
        r="3"
        fill="#F2413D"
      />
    </svg>
    <div class="regenere-eyebrow">CONNECTION ISSUE</div>
    <h1 class="regenere-heading">
      <span class="regenere-heading-text">Sorry, we couldn't confirm your formula just now.</span>
    </h1>
    <div class="regenere-body">
      <p>Something on our end interrupted the request. Your order has not been affected.</p>
      <p>
        If the issue persists, it may be a temporary connection or server error. A second attempt
        usually resolves it.
      </p>
    </div>
    <button
      class="regenere-button"
      @click="retry"
    >
      Retry Confirmation
    </button>
    <p class="regenere-help">
      Still having trouble? Please
      <a
        href="https://www.regenere.com/pages/contact"
        target="_blank"
        rel="noopener"
        >contact us</a
      >
      with your order number.
    </p>
  </div>
</template>

<script>
export default {
  name: "RegenereFailurePage",
  emits: ["retry"],
  methods: {
    retry() {
      this.$emit("retry");
    },
  },
};
</script>

<style scoped>
.regenere-result-page {
  background-color: #f5f1e7;
  min-height: calc(100vh - 44px);
  width: 100%;
  flex: 1 1 auto;
  padding: 80px 20px 60px;
  text-align: center;
}

.regenere-warning {
  width: 96px;
  height: 96px;
}

.regenere-eyebrow {
  margin-top: 18px;
  font-family: "DM Sans", sans-serif;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.08em;
  color: #f2413d;
  text-transform: uppercase;
}

.regenere-heading {
  margin-top: 36px;
  font-family: "Cormorant Garamond", "Playfair Display", "Times New Roman", serif;
  font-weight: 700;
  font-size: 30px;
  line-height: 1.15;
  max-width: 960px;
}

.regenere-heading-text {
  display: inline-block;
  background: linear-gradient(90deg, #000 0%, #000 30%, #e3a52a 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.regenere-body {
  margin-top: 28px;
  font-family: "DM Sans", sans-serif;
  font-size: 16px;
  line-height: 1.3;
  color: #1a1a1a;
  max-width: 820px;
}

.regenere-body p {
  margin: 0;
}

.regenere-body p + p {
  margin-top: 4px;
}

.regenere-button {
  margin-top: 36px;
  width: 280px;
  padding: 18px 24px;
  background-color: #cdaa4c;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-family: "DM Sans", sans-serif;
  font-size: 16px;
  line-height:16px;
  font-weight: 600;
  letter-spacing: -0.01em;
  cursor: pointer;
}

.regenere-button:hover {
  background-color: #b69239;
}

.regenere-help {
  margin-top: 28px;
  font-size: 16px;
  color: #1a1a1a;
}

.regenere-help a {
  color: #1a1a1a;
  text-decoration: underline;
}

@media (min-width: 768px) {
  .regenere-result-page {
    min-height: calc(100vh - 76px);
    padding: 120px 40px 80px;
  }
  .regenere-heading {
    font-size: 44px;
    letter-spacing: 0.02em;
  }
  .regenere-body {
    margin-top: 32px;
    font-size: 20px;
  }
  .regenere-button {
    width: 320px;
    padding: 21px 24px;
    font-size: 18px;
    line-height:18px;
  }
  .regenere-help {
    font-size: 18px;
  }
}
</style>
